import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// A client that always authenticates as the agency user, regardless of the current path.
// Used by agency-only features (e.g. Internal Projects) that render inside a client workspace.
export const agencyApi = axios.create({ baseURL: API });
agencyApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_agency_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Choose token by current path: the console (/console, and legacy /agency during redirect) uses the agency token, everything else the workspace token.
api.interceptors.request.use((config) => {
  const path = window.location.pathname;
  const token = (path.startsWith("/console") || path === "/agency" || path.startsWith("/agency/"))
    ? localStorage.getItem("mc_agency_token")
    : localStorage.getItem("mc_ws_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function agencyToken() { return localStorage.getItem("mc_agency_token"); }
export function wsToken() { return localStorage.getItem("mc_ws_token"); }

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function workspaceLogoUrl(ws) {
  if (!ws?.logo_path) return null;
  return `${API}/workspaces/${ws.id}/logo?v=${encodeURIComponent(ws.logo_path)}`;
}

export function agencyLogoUrl(agency) {
  if (!agency?.agency_logo_path) return null;
  return `${API}/agency/logo?v=${encodeURIComponent(agency.agency_logo_path)}`;
}

export function avatarUrl(userId, version) {
  if (!userId) return null;
  return `${API}/users/${userId}/avatar${version ? `?v=${encodeURIComponent(version)}` : ""}`;
}

export function applyMeta({ meta_title, meta_description } = {}) {
  if (meta_title) document.title = meta_title;
  if (meta_description) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
    m.setAttribute("content", meta_description);
  }
}
